<template>
  <div style="width: 100%; height: 100%">
    <div style="width: 100%">
      <div style="width: 95%; height: 40px">
        <el-row style="margin: 10px; width: 95%; display: flex; flex-direction: row-reverse">
          <el-button type="danger" size="small" @click="BoxOpen">
            新增{{ level == 0 ? '目录' : level == 1 ? '菜单' : '按钮' }}
          </el-button>
          <el-button type="primary" size="small" @click="resetSearch" style="margin-right: 10px">
            重置
          </el-button>
          <el-button type="primary" size="small" @click="partserch" style="margin-right: 10px">
            搜索
          </el-button>
          <el-input v-model="formDatas.authName" placeholder="搜索菜单名称" clearable size="small"
            style="width: 200px; margin-right: 10px"></el-input>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss">
        <el-tabs v-model="editableTabsValue" type="card" :closable="level != 0" @edit="handleTabsEdit"
          @tab-click="tabsClick" style="width: 100%; margin: 10px auto 0">
          <el-tab-pane :key="index" v-for="(item, index) in editableTabs" :label="item.title" :name="item.name"
            style="width: 91%"></el-tab-pane>
        </el-tabs>
        <el-table ref="multipleTable" :data="tableData" stripe border style="width: 100%" :max-height="tableHight"
          :cell-style="{ textAlign: 'center' }" :header-cell-style="{
            textAlign: 'center',
            background: 'rgba(0,170,255,0.5)',
            color: 'black',
            border: 'none',
          }">
          <el-table-column type="index" width="50" label="序号"> </el-table-column>
          <el-table-column prop="authName" label="菜单名称"> </el-table-column>
          <el-table-column prop="authUrl" label="菜单地址"> </el-table-column>
          <el-table-column prop="authRemark" label="描述"> </el-table-column>
          <el-table-column prop="authParams" label="接口参数"> </el-table-column>
          <el-table-column prop="authOrder" label="排序" width="80"> </el-table-column>
          <el-table-column prop="authIcon" label="图标" width="100"> </el-table-column>
          <el-table-column prop="authOperationType" label="操作类型" width="100">
            <template slot-scope="scope">
              <el-tag size="mini" type="primary" disable-transitions>{{
                scope.row.authOperationType == 0 ? '查询' : scope.row.authOperationType == 1 ? '新增' : scope.row.authOperationType == 2 ? '编辑' : '删除'
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createtime" label="创建时间" width="160"> </el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleLevel(scope.row)">
                {{ scope.row.authType == 0 ? '查看菜单' : '查看按钮' }}
              </el-button>
              <el-button size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button size="mini" type="text" @click="handleDelete(scope.row)" style="color: red">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="width: 100%; height: 60px">
        <div style="width: 100%; height: 100%; margin-top: 10px">
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :page-sizes="[20, 50, 80, 100, 300, 500, 1000]" background layout="total,sizes,prev, pager, next"
            :page-size="20" :total="totals" :current-page="currentPage">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 新增/编辑弹框 -->
    <el-drawer :title="edit == true ? '编辑功能' : '新增功能'" :wrapperClosable="false" :before-close="handleClose"
      :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
      <div class="demo-drawer__content" style="padding: 50px">
        <el-form :model="form" label-position="top" :rules="rules">
          <el-form-item label="父级权限id" label-width="120">
            <el-input v-model="form.authParentId" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="菜单权限名称" label-width="120">
            <el-input v-model="form.authName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="地址" label-width="120">
            <el-input v-model="form.authUrl" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="接口参数" label-width="120">
            <el-input v-model="form.authParams" type="textarea" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="描述" label-width="120">
            <el-input v-model="form.authRemark" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="排序" label-width="120">
            <el-input v-model="form.authOrder" type="number" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="图标" label-width="120">
            <el-input v-model="form.authIcon" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="操作类型(0查询 1新增 2编辑 3删除)" label-width="120">
            <el-input v-model="form.authOperationType" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer" style="margin-top: 50px">
          <el-button @click="cancelForm" style="margin-left: 50px">取 消</el-button>
          <el-button type="primary" @click="open" :loading="loading">{{
            loading ? '提交中 ...' : '确 定'
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getAyAuthList,
  addAyAuth,
  updateAyAuth,
  deleteAyAuth,
} from "../../api/api";
export default {
  name: "authority",
  data() {
    return {
      authParentId: 0,
      editableTabsValue: "0",
      editableTabs: [
        {
          title: "目录",
          name: "0",
        },
      ],
      tabIndex: 0,
      level: 0,
      dialog: false,
      edit: false,
      form: {
        authName: "",
        authType: "",
        authParentId: "",
        authUrl: "",
        authParams: "",
        authRemark: "",
        authOrder: "",
        authIcon: "",
        authOperationType: "",
      },
      rules: {},
      diashow: false,
      loading: false,
      timer: null,
      tableHight: 720,
      watchFlag: false,
      windheight: "",
      tableData: [],
      currentPage: 1,
      totals: null,
      formDatas: {
        authName: "",
        authType: 0,
        authParentId: 0,
        currentPage: 1,
        pageSize: 20,
      },
    };
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = val - 200 - val * 0.04;
        }
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
      this.getList();
    });
  },
  created() {
    this.windheight = this.$store.state.windheight;
    this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    this.getList();
  },
  methods: {
    tabsClick(e) {
      this.editableTabsValue = e.name;
      this.tabIndex = this.editableTabsValue;
      this.level = this.tabIndex * 1;
      // 一级菜单(level=0)的父级ID固定为0，二级菜单才从tabs获取
      const parentId = this.level === 0 ? 0 : (this.editableTabs[e.index * 1].authParentId || 0);
      this.form.authParentId = parentId;
      this.authParentId = parentId;
      this.formDatas.authParentId = parentId;
      this.partserch();
    },
    handleTabsEdit(targetName, action) {
      if (action === "remove") {
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }
        this.editableTabsValue = activeName;
        const tabarr = (this.editableTabs = tabs.filter(
          (tab) => tab.name !== targetName
        ));
        this.tabIndex = tabarr[tabarr.length - 1].name;
        this.level = tabarr[tabarr.length - 1].name * 1;
        // 一级菜单(level=0)的父级ID固定为0，二级菜单才从tabs获取
        const parentId = this.level === 0 ? 0 : (tabarr[tabarr.length - 1].authParentId || 0);
        this.form.authParentId = parentId;
        this.authParentId = parentId;
        this.formDatas.authParentId = parentId;
        this.partserch();
      }
    },
    handleLevel(row) {
      if (row.authRemark && row.authRemark.indexOf("#", 0) > -1) {
        this.level = 2;
        this.tabIndex = this.editableTabsValue = 2 + "";
      } else {
        this.level = row.authType + 1;
        this.tabIndex = this.editableTabsValue = row.authType + 1 + "";
      }
      this.formDatas.authParentId = this.authParentId = row.authId;
      const s = {
        title: this.level == 1 ? "菜单" : "按钮",
        name: this.tabIndex,
        authParentId: row.authId,
      };
      this.editableTabs.some((item, index) => {
        if (item.name === s.name) {
          this.editableTabs.splice(index, 1, s);
          this.partserch();
          return true;
        } else if (
          index == this.editableTabs.length - 1 &&
          item.name != s.name
        ) {
          this.editableTabs.push(s);
          this.partserch();
        }
      });
    },
    handleDelete(row) {
      this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAyAuth({ authId: row.authId }).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.partserch();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    handleEdit(row) {
      const data = JSON.parse(JSON.stringify(row));
      this.dialog = true;
      this.edit = true;
      this.$nextTick(() => {
        this.form = data;
      });
    },
    open() {
      this.diashow = true;
      this.$refs.drawer.closeDrawer();
    },
    handleClose(done) {
      if (this.diashow == false) {
        this.$confirm("确认关闭？")
          .then((_) => {
            done();
          })
          .catch((_) => {});
        this.resetForm();
        this.diashow = false;
      } else {
        if (this.edit == true) {
          this.$confirm("确定要编辑吗？")
            .then((_) => {
              updateAyAuth(this.form).then((res) => {
                if (!res) return;
                this.$message({
                  showClose: true,
                  message: "编辑成功",
                  type: "success",
                });
                this.getList();
                this.resetForm();
                done();
                
                this.diashow = false;
              });
            })
            .catch((_) => {});
          this.diashow = false;
        } else {
          this.$confirm("确定要新增吗？")
            .then((_) => {
              addAyAuth(this.form).then((res) => {
                if (!res) return;
                this.$message({
                  showClose: true,
                  message: "新增成功",
                  type: "success",
                });
                this.getList();
                this.resetForm();
                done();
                this.diashow = false;
              });
            })
            .catch((_) => {});
          this.diashow = false;
        }
      }
    },
    resetForm() {
      this.form = {
        authName: "",
        authType: "",
        authParentId: "",
        authUrl: "",
        authParams: "",
        authRemark: "",
        authOrder: "",
        authIcon: "",
        authOperationType: "",
      };
      this.edit = false;
    },
    cancelForm() {
      this.resetForm();
      this.loading = false;
      this.dialog = false;
      clearTimeout(this.timer);
    },
    BoxOpen() {
      this.form.authType = this.level;
      this.form.authParentId = this.authParentId;
      this.dialog = true;
    },
    handleSizeChange(val) {
      this.formDatas.pageSize = val;
      this.partserch();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.formDatas.currentPage = val;
      getAyAuthList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totals = res.total;
      });
    },
    partserch() {
      this.formDatas.authType = this.level;
      this.formDatas.currentPage = 1;
      this.currentPage = 1;
      getAyAuthList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totals = res.total;
      });
    },
    resetSearch() {
      this.formDatas.authName = "";
      this.partserch();
    },
    getList() {
      getAyAuthList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totals = res.total;
      });
    },
  },
};
</script>

<style scoped>
.tablecss {
  padding: 15px;
  overflow-y: hidden;
}

div /deep/ .el-pagination__total {
  margin-right: 35%;
  margin-left: 5%;
}
</style>
